module.exports = __webpack_public_path__ + "static/media/appliances.9e72829e.svg";